/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { assumptionEntryDtoSchema } from "./assumptionEntryDtoSchema.ts";
import { investorTypeRowDtoSchema } from "./investorTypeRowDtoSchema.ts";
import { marketTierRowDtoSchema } from "./marketTierRowDtoSchema.ts";
import { z } from "zod/v4";

export const marketSizeInvestorsDtoSchema = z.object({
  get tiers() {
    return z.array(marketTierRowDtoSchema).optional();
  },
  get somAssumptions() {
    return z.array(assumptionEntryDtoSchema).optional();
  },
  investorListHeading: z.optional(z.string()),
  get investorList() {
    return z.array(investorTypeRowDtoSchema).optional();
  },
});
